export default __webpack_public_path__ + "static/media/glass_f.704c74f7.svg";